import { AspectRatio, Box, Button, Modal, Text } from 'native-base'
import Colors from '../Constants/Colors'
import { Image } from 'react-native'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Dictionary, groupBy } from 'lodash'
import { ppw } from '../Utils/LogUtil'

const PopupGachaResult = ({
  result,
  onClose,
}: {
  result: GachaDrawRes
  onClose: () => void
}) => {
  //=========== HOOK ==========
  const { t } = useTranslation()

  // result = {
  //   title: '2nd',
  //   image:
  //     'https://dev-bucket.genkimiru.jp/dev.genki.uploads/upload/imgs/icons/lucky_draw/677479126.png',
  //   remain: 1,
  //   details: [
  //     {
  //       title: '2nd',
  //       edy: 0,
  //     },
  //     {
  //       title: 'Miss',
  //       edy: 0,
  //     },
  //     {
  //       title: 'Miss',
  //       edy: 0,
  //     },
  //     {
  //       title: '3rd',
  //       edy: 0,
  //     },
  //     // {
  //     //   "title": "2nd",
  //     //   "edy": 5
  //     // }
  //   ],
  // }

  let isGoodLuck: boolean =
    result.details?.every((value) => value.edy == 0) ?? true

  let isOnceSprint = (result.details?.length ?? 0) === 1

  //=========== CONTENT ==========
  const getContentView = (): any => {
    ppw('getContentView().result', result)

    if (isGoodLuck) {
      return (
        <Text
          fontSize={22}
          marginX={4}
          textAlign={'center'}
          color={Colors.black}
          // style={{
          //   backgroundColor: Colors.redText,
          // }}
        >
          {isOnceSprint
            ? t('Missing')
            : t(`Miss val times`, { val: result.details?.length ?? 0 })}
        </Text>
      )
    } else {
      let listView = []

      const detailG: Dictionary<GachaDrawDetailRes[]> = groupBy(
        result.details,
        (x) => x.edy
      )

      ppw('getContentView().detailG', detailG)

      let keyCount = 0
      for (let edyG in detailG) {
        keyCount += 1
        let detailListG = detailG[edyG]

        let isGoodLuckG = edyG.trim() === '0'

        if (isGoodLuckG) {
          listView.push(
            <Text
              key={keyCount}
              fontSize={22}
              textAlign={'center'}
              color={Colors.black}
              // style={{
              //   backgroundColor: Colors.redText,
              // }}
            >
              {isOnceSprint
                ? t('Missing')
                : t(`Miss val times`, { val: detailListG.length ?? 0 })}
            </Text>
          )
        } else {
          listView.push(
            <Text
              key={keyCount}
              fontSize={22}
              textAlign={'center'}
              color={Colors.black}
              // style={{
              //   backgroundColor: Colors.redText,
              // }}
            >
              {isOnceSprint
                ? t(`You won val pt`, { val: edyG })
                : t(`You won val1 e money reward val2 times`, {
                    val1: edyG,
                    val2: detailListG.length,
                  })}
            </Text>
          )
        }
      }
      return listView.reverse()
    }
  }

  //=========== OUT ==========
  return (
    <Modal isOpen={true} onClose={onClose}>
      <Modal.Content maxWidth="80%" borderRadius={20}>
        <Box justifyContent={'center'} alignItems={'center'}>
          <Text
            color={isGoodLuck ? Colors.gachaGoodLuck : Colors.redError}
            marginX={4}
            marginTop={4}
            fontSize={22}
            // style={{
            //   backgroundColor: Colors.primaryColor,
            // }}
          >
            {isGoodLuck ? t('Better luck next time') : t('Congratulation')}
          </Text>
          <Box
            justifyContent={'center'}
            alignItems={'center'}
            mx={'20px'}
            my={'8px'}
          >
            {getContentView()}
          </Box>
          <AspectRatio
            ratio={{
              base: 16 / 9,
            }}
            width={{
              base: '100%',
            }}
          >
            <Image
              source={{
                uri: result.image,
                // uri: null,
              }}
              resizeMode={'cover'}
            />
          </AspectRatio>
          <Button
            style={{
              backgroundColor: Colors.primaryColor,
              width: '100%',
            }}
            _text={{
              color: 'black',
              fontSize: 22,
            }}
            size={'lg'}
            onPress={onClose}
          >
            {t('OK')}
          </Button>
        </Box>
      </Modal.Content>
    </Modal>
  )
}

export default PopupGachaResult
